import { tokens } from '@equinor/eds-tokens';

const parseSpacing = (spacing: string): number => Number(spacing.replace('px', ''));

export const Typography = {
  htmlFontSize: 16,
  fontFamily: 'Inter',
  h1: {
    fontFamily: 'Equinor',
    fontSize: tokens.typography.heading.h1.fontSize,
    fontWeight: tokens.typography.heading.h1.fontWeight,
    lineHeight: tokens.typography.heading.h1.lineHeight,
    marginBottom: parseSpacing(tokens.spacings.comfortable.large),
  },
  h2: {
    fontFamily: 'Equinor',
    fontSize: tokens.typography.heading.h2.fontSize,
    fontWeight: tokens.typography.heading.h2.fontWeight,
    lineHeight: tokens.typography.heading.h2.lineHeight,
    marginBottom: parseSpacing(tokens.spacings.comfortable.large),
  },
  h3: {
    fontFamily: 'Equinor',
    fontSize: tokens.typography.heading.h3.fontSize,
    fontWeight: tokens.typography.heading.h3.fontWeight,
    lineHeight: tokens.typography.heading.h3.lineHeight,
    marginBottom: parseSpacing(tokens.spacings.comfortable.medium),
  },
  h4: {
    fontFamily: 'Equinor',
    fontSize: tokens.typography.heading.h4.fontSize,
    fontWeight: tokens.typography.heading.h4.fontWeight,
    lineHeight: tokens.typography.heading.h4.lineHeight,
    marginBottom: parseSpacing(tokens.spacings.comfortable.medium),
  },
  h5: {
    fontFamily: 'Equinor',
    fontSize: tokens.typography.heading.h5.fontSize,
    fontWeight: tokens.typography.heading.h5.fontWeight,
    lineHeight: tokens.typography.heading.h5.lineHeight,
    marginBottom: parseSpacing(tokens.spacings.comfortable.small),
  },
  h6: {
    fontFamily: 'Equinor',
    fontSize: tokens.typography.heading.h6.fontSize,
    fontWeight: tokens.typography.heading.h6.fontWeight,
    lineHeight: tokens.typography.heading.h6.lineHeight,
    marginBottom: parseSpacing(tokens.spacings.comfortable.small),
  },
};
